// src/components/NotificationPrompt.js — iOS SAFE
import { useState } from 'react'
import { usePushNotifications } from '../hooks/useNotifications'
import './NotificationPrompt.css'

export default function NotificationPrompt({ userId }) {
  // Safe dismiss state
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem('notif-dismissed') === 'true' } catch { return true }
  })

  let permission = 'default', subscribed = false, loading = false, requestPermission = () => {}
  try {
    const hook = usePushNotifications(userId)
    permission = hook.permission
    subscribed = hook.subscribed
    loading = hook.loading
    requestPermission = hook.requestPermission
  } catch { return null }

  if (permission === 'granted' || subscribed || dismissed) return null
  if (permission === 'denied' || permission === 'unsupported') return null
  // Don't show on iOS - notifications not fully supported
  try { if (!('Notification' in window)) return null } catch { return null }

  function dismiss() {
    try { localStorage.setItem('notif-dismissed', 'true') } catch {}
    setDismissed(true)
  }

  return (
    <div className="notif-prompt">
      <div className="notif-prompt__icon">🔔</div>
      <div className="notif-prompt__content">
        <p className="notif-prompt__title">Stay in the loop</p>
        <p className="notif-prompt__sub">Get notified when Sky Bri replies or drops new content</p>
      </div>
      <div className="notif-prompt__actions">
        <button className="btn btn--gold btn--sm" onClick={requestPermission} disabled={loading}>
          {loading ? 'Enabling...' : 'Enable'}
        </button>
        <button className="btn btn--ghost btn--sm" onClick={dismiss}>Not now</button>
      </div>
    </div>
  )
}
